[
  {
    "code": "ab",
    "name": "Abkhazian",
    "native": "Аҧсуа"
  },
  {
    "code": "aa",
    "name": "Afar",
    "native": "Afar"
  },
  {
    "code": "af",
    "name": "Afrikaans",
    "native": "Afrikaans"
  },
  {
    "code": "ak",
    "name": "Akan",
    "native": "Akana"
  },
  {
    "code": "sq",
    "name": "Albanian",
    "native": "Shqip"
  },
  {
    "code": "am",
    "name": "Amharic",
    "native": "አማርኛ"
  },
  {
    "code": "ar",
    "name": "Arabic",
    "native": "العربية",
    "rtl": 1
  },
  {
    "code": "an",
    "name": "Aragonese",
    "native": "Aragonés"
  },
  {
    "code": "hy",
    "name": "Armenian",
    "native": "Հայերեն"
  },
  {
    "code": "as",
    "name": "Assamese",
    "native": "অসমীয়া"
  },
  {
    "code": "av",
    "name": "Avar",
    "native": "Авар"
  },
  {
    "code": "ay",
    "name": "Aymara",
    "native": "Aymar"
  },
  {
    "code": "az",
    "name": "Azerbaijani",
    "native": "Azərbaycanca / آذربايجان"
  },
  {
    "code": "bm",
    "name": "Bambara",
    "native": "Bamanankan"
  },
  {
    "code": "ba",
    "name": "Bashkir",
    "native": "Башҡорт"
  },
  {
    "code": "eu",
    "name": "Basque",
    "native": "Euskara"
  },
  {
    "code": "be",
    "name": "Belarusian",
    "native": "Беларуская"
  },
  {
    "code": "bn",
    "name": "Bengali",
    "native": "বাংলা"
  },
  {
    "code": "bh",
    "name": "Bihari",
    "native": "भोजपुरी"
  },
  {
    "code": "bi",
    "name": "Bislama",
    "native": "Bislama"
  },
  {
    "code": "bs",
    "name": "Bosnian",
    "native": "Bosanski"
  },
  {
    "code": "br",
    "name": "Breton",
    "native": "Brezhoneg"
  },
  {
    "code": "bg",
    "name": "Bulgarian",
    "native": "Български"
  },
  {
    "code": "my",
    "name": "Burmese",
    "native": "မြန်မာစာ"
  },
  {
    "code": "km",
    "name": "Cambodian",
    "native": "ភាសាខ្មែរ"
  },
  {
    "code": "ca",
    "name": "Catalan",
    "native": "Català"
  },
  {
    "code": "ch",
    "name": "Chamorro",
    "native": "Chamoru"
  },
  {
    "code": "ce",
    "name": "Chechen",
    "native": "Нохчийн"
  },
  {
    "code": "ny",
    "name": "Chichewa",
    "native": "Chi-Chewa"
  },
  {
    "code": "zh",
    "name": "Chinese",
    "native": "中文"
  },
  {
    "code": "cv",
    "name": "Chuvash",
    "native": "Чăваш"
  },
  {
    "code": "kw",
    "name": "Cornish",
    "native": "Kernewek"
  },
  {
    "code": "co",
    "name": "Corsican",
    "native": "Corsu"
  },
  {
    "code": "cr",
    "name": "Cree",
    "native": "Nehiyaw"
  },
  {
    "code": "hr",
    "name": "Croatian",
    "native": "Hrvatski"
  },
  {
    "code": "cs",
    "name": "Czech",
    "native": "Česky"
  },
  {
    "code": "da",
    "name": "Danish",
    "native": "Dansk"
  },
  {
    "code": "dv",
    "name": "Divehi",
    "native": "ދިވެހިބަސް",
    "rtl": 1
  },
  {
    "code": "nl",
    "name": "Dutch",
    "native": "Nederlands"
  },
  {
    "code": "dz",
    "name": "Dzongkha",
    "native": "ཇོང་ཁ"
  },
  {
    "code": "en",
    "name": "English",
    "native": "English"
  },
  {
    "code": "eo",
    "name": "Esperanto",
    "native": "Esperanto"
  },
  {
    "code": "et",
    "name": "Estonian",
    "native": "Eesti"
  },
  {
    "code": "ee",
    "name": "Ewe",
    "native": "Ɛʋɛ"
  },
  {
    "code": "fo",
    "name": "Faroese",
    "native": "Føroyskt"
  },
  {
    "code": "fj",
    "name": "Fijian",
    "native": "Na Vosa Vakaviti"
  },
  {
    "code": "fi",
    "name": "Finnish",
    "native": "Suomi"
  },
  {
    "code": "fr",
    "name": "French",
    "native": "Français"
  },
  {
    "code": "gl",
    "name": "Galician",
    "native": "Galego"
  },
  {
    "code": "lg",
    "name": "Ganda",
    "native": "Luganda"
  },
  {
    "code": "ka",
    "name": "Georgian",
    "native": "ქართული"
  },
  {
    "code": "de",
    "name": "German",
    "native": "Deutsch"
  },
  {
    "code": "el",
    "name": "Greek",
    "native": "Ελληνικά"
  },
  {
    "code": "kl",
    "name": "Greenlandic",
    "native": "Kalaallisut"
  },
  {
    "code": "gn",
    "name": "Guarani",
    "native": "Avañe'ẽ"
  },
  {
    "code": "gu",
    "name": "Gujarati",
    "native": "ગુજરાતી"
  },
  {
    "code": "ht",
    "name": "Haitian",
    "native": "Krèyol ayisyen"
  },
  {
    "code": "ha",
    "name": "Hausa",
    "native": "هَوُسَ",
    "rtl": 1
  },
  {
    "code": "he",
    "name": "Hebrew",
    "native": "עברית",
    "rtl": 1
  },
  {
    "code": "hz",
    "name": "Herero",
    "native": "Otsiherero"
  },
  {
    "code": "hi",
    "name": "Hindi",
    "native": "हिन्दी"
  },
  {
    "code": "ho",
    "name": "Hiri Motu",
    "native": "Hiri Motu"
  },
  {
    "code": "hu",
    "name": "Hungarian",
    "native": "Magyar"
  },
  {
    "code": "is",
    "name": "Icelandic",
    "native": "Íslenska"
  },
  {
    "code": "io",
    "name": "Ido",
    "native": "Ido"
  },
  {
    "code": "ig",
    "name": "Igbo",
    "native": "Igbo"
  },
  {
    "code": "id",
    "name": "Indonesian",
    "native": "Bahasa Indonesia"
  },
  {
    "code": "ia",
    "name": "Interlingua",
    "native": "Interlingua"
  },
  {
    "code": "ie",
    "name": "Interlingue",
    "native": "Interlingue"
  },
  {
    "code": "iu",
    "name": "Inuktitut",
    "native": "ᐃᓄᒃᑎᑐᑦ"
  },
  {
    "code": "ik",
    "name": "Inupiak",
    "native": "Iñupiak"
  },
  {
    "code": "ga",
    "name": "Irish",
    "native": "Gaeilge"
  },
  {
    "code": "it",
    "name": "Italian",
    "native": "Italiano"
  },
  {
    "code": "ja",
    "name": "Japanese",
    "native": "日本語"
  },
  {
    "code": "jv",
    "name": "Javanese",
    "native": "Basa Jawa"
  },
  {
    "code": "kn",
    "name": "Kannada",
    "native": "ಕನ್ನಡ"
  },
  {
    "code": "kr",
    "name": "Kanuri",
    "native": "Kanuri"
  },
  {
    "code": "ks",
    "name": "Kashmiri",
    "native": "कश्मीरी / كشميري",
    "rtl": 1
  },
  {
    "code": "kk",
    "name": "Kazakh",
    "native": "Қазақша"
  },
  {
    "code": "ki",
    "name": "Kikuyu",
    "native": "Gĩkũyũ"
  },
  {
    "code": "ky",
    "name": "Kirghiz",
    "native": "Kırgızca / Кыргызча"
  },
  {
    "code": "rn",
    "name": "Kirundi",
    "native": "Kirundi"
  },
  {
    "code": "kv",
    "name": "Komi",
    "native": "Коми"
  },
  {
    "code": "kg",
    "name": "Kongo",
    "native": "KiKongo"
  },
  {
    "code": "ko",
    "name": "Korean",
    "native": "한국어"
  },
  {
    "code": "kj",
    "name": "Kuanyama",
    "native": "Kuanyama"
  },
  {
    "code": "ku",
    "name": "Kurdish",
    "native": "Kurdî / كوردی",
    "rtl": 1
  },
  {
    "code": "lo",
    "name": "Laotian",
    "native": "ລາວ / Pha xa lao"
  },
  {
    "code": "la",
    "name": "Latin",
    "native": "Latina"
  },
  {
    "code": "lv",
    "name": "Latvian",
    "native": "Latviešu"
  },
  {
    "code": "li",
    "name": "Limburgian",
    "native": "Limburgs"
  },
  {
    "code": "ln",
    "name": "Lingala",
    "native": "Lingála"
  },
  {
    "code": "lt",
    "name": "Lithuanian",
    "native": "Lietuvių"
  },
  {
    "code": "lu",
    "name": "Luba-Katanga",
    "native": "Tshiluba"
  },
  {
    "code": "lb",
    "name": "Luxembourgish",
    "native": "Lëtzebuergesch"
  },
  {
    "code": "mk",
    "name": "Macedonian",
    "native": "Македонски"
  },
  {
    "code": "mg",
    "name": "Malagasy",
    "native": "Malagasy"
  },
  {
    "code": "ms",
    "name": "Malay",
    "native": "Bahasa Melayu"
  },
  {
    "code": "ml",
    "name": "Malayalam",
    "native": "മലയാളം"
  },
  {
    "code": "mt",
    "name": "Maltese",
    "native": "bil-Malti"
  },
  {
    "code": "gv",
    "name": "Manx",
    "native": "Gaelg"
  },
  {
    "code": "mi",
    "name": "Maori",
    "native": "Māori"
  },
  {
    "code": "mr",
    "name": "Marathi",
    "native": "मराठी"
  },
  {
    "code": "mh",
    "name": "Marshallese",
    "native": "Kajin Majel / Ebon"
  },
  {
    "code": "mo",
    "name": "Moldovan",
    "native": "Moldovenească"
  },
  {
    "code": "mn",
    "name": "Mongolian",
    "native": "Монгол"
  },
  {
    "code": "na",
    "name": "Nauruan",
    "native": "Dorerin Naoero"
  },
  {
    "code": "nv",
    "name": "Navajo",
    "native": "Diné bizaad"
  },
  {
    "code": "ng",
    "name": "Ndonga",
    "native": "Oshiwambo"
  },
  {
    "code": "ne",
    "name": "Nepali",
    "native": "नेपाली"
  },
  {
    "code": "nd",
    "name": "North Ndebele",
    "native": "Sindebele"
  },
  {
    "code": "se",
    "name": "Northern Sami",
    "native": "Sámegiella"
  },
  {
    "code": "no",
    "name": "Norwegian",
    "native": "Norsk"
  },
  {
    "code": "nb",
    "name": "Norwegian Bokmål",
    "native": "Norsk bokmål"
  },
  {
    "code": "nn",
    "name": "Norwegian Nynorsk",
    "native": "Norsk nynorsk"
  },
  {
    "code": "oc",
    "name": "Occitan",
    "native": "Occitan"
  },
  {
    "code": "oj",
    "name": "Ojibwa",
    "native": "ᐊᓂᔑᓈᐯᒧᐎᓐ / Anishinaabemowin"
  },
  {
    "code": "cu",
    "name": "Old Church Slavonic / Old Bulgarian",
    "native": "словѣньскъ / slověnĭskŭ"
  },
  {
    "code": "or",
    "name": "Oriya",
    "native": "ଓଡ଼ିଆ"
  },
  {
    "code": "om",
    "name": "Oromo",
    "native": "Oromoo"
  },
  {
    "code": "os",
    "name": "Ossetian / Ossetic",
    "native": "Иронау"
  },
  {
    "code": "pi",
    "name": "Pali",
    "native": "Pāli / पाऴि"
  },
  {
    "code": "pa",
    "name": "Panjabi / Punjabi",
    "native": "ਪੰਜਾਬੀ / पंजाबी / پنجابي"
  },
  {
    "code": "ps",
    "name": "Pashto",
    "native": "پښتو",
    "rtl": 1
  },
  {
    "code": "fa",
    "name": "Persian",
    "native": "فارسی",
    "rtl": 1
  },
  {
    "code": "ff",
    "name": "Peul",
    "native": "Fulfulde"
  },
  {
    "code": "pl",
    "name": "Polish",
    "native": "Polski"
  },
  {
    "code": "pt",
    "name": "Portuguese",
    "native": "Português"
  },
  {
    "code": "qu",
    "name": "Quechua",
    "native": "Runa Simi"
  },
  {
    "code": "rm",
    "name": "Raeto Romance",
    "native": "Rumantsch"
  },
  {
    "code": "ro",
    "name": "Romanian",
    "native": "Română"
  },
  {
    "code": "ru",
    "name": "Russian",
    "native": "Русский"
  },
  {
    "code": "rw",
    "name": "Rwandi",
    "native": "Kinyarwandi"
  },
  {
    "code": "sm",
    "name": "Samoan",
    "native": "Gagana Samoa"
  },
  {
    "code": "sg",
    "name": "Sango",
    "native": "Sängö"
  },
  {
    "code": "sa",
    "name": "Sanskrit",
    "native": "संस्कृतम्"
  },
  {
    "code": "sc",
    "name": "Sardinian",
    "native": "Sardu"
  },
  {
    "code": "gd",
    "name": "Scottish Gaelic",
    "native": "Gàidhlig"
  },
  {
    "code": "sr",
    "name": "Serbian",
    "native": "Српски"
  },
  {
    "code": "sh",
    "name": "Serbo-Croatian",
    "native": "Srpskohrvatski / Српскохрватски"
  },
  {
    "code": "sn",
    "name": "Shona",
    "native": "chiShona"
  },
  {
    "code": "ii",
    "name": "Sichuan Yi",
    "native": "ꆇꉙ / 四川彝语"
  },
  {
    "code": "sd",
    "name": "Sindhi",
    "native": "सिनधि"
  },
  {
    "code": "si",
    "name": "Sinhalese",
    "native": "සිංහල"
  },
  {
    "code": "sk",
    "name": "Slovak",
    "native": "Slovenčina"
  },
  {
    "code": "sl",
    "name": "Slovenian",
    "native": "Slovenščina"
  },
  {
    "code": "so",
    "name": "Somalia",
    "native": "Soomaaliga"
  },
  {
    "code": "nr",
    "name": "South Ndebele",
    "native": "isiNdebele"
  },
  {
    "code": "st",
    "name": "Southern Sotho",
    "native": "Sesotho"
  },
  {
    "code": "es",
    "name": "Spanish",
    "native": "Español"
  },
  {
    "code": "su",
    "name": "Sundanese",
    "native": "Basa Sunda"
  },
  {
    "code": "sw",
    "name": "Swahili",
    "native": "Kiswahili"
  },
  {
    "code": "ss",
    "name": "Swati",
    "native": "SiSwati"
  },
  {
    "code": "sv",
    "name": "Swedish",
    "native": "Svenska"
  },
  {
    "code": "tl",
    "name": "Tagalog / Filipino",
    "native": "Tagalog"
  },
  {
    "code": "ty",
    "name": "Tahitian",
    "native": "Reo Mā`ohi"
  },
  {
    "code": "tg",
    "name": "Tajik",
    "native": "Тоҷикӣ"
  },
  {
    "code": "ta",
    "name": "Tamil",
    "native": "தமிழ்"
  },
  {
    "code": "tt",
    "name": "Tatar",
    "native": "Tatarça"
  },
  {
    "code": "te",
    "name": "Telugu",
    "native": "తెలుగు"
  },
  {
    "code": "th",
    "name": "Thai",
    "native": "ไทย / Phasa Thai"
  },
  {
    "code": "bo",
    "name": "Tibetan",
    "native": "བོད་ཡིག / Bod skad"
  },
  {
    "code": "ti",
    "name": "Tigrinya",
    "native": "ትግርኛ"
  },
  {
    "code": "to",
    "name": "Tonga",
    "native": "Lea Faka-Tonga"
  },
  {
    "code": "ts",
    "name": "Tsonga",
    "native": "Xitsonga"
  },
  {
    "code": "tn",
    "name": "Tswana",
    "native": "Setswana"
  },
  {
    "code": "tr",
    "name": "Turkish",
    "native": "Türkçe"
  },
  {
    "code": "tk",
    "name": "Turkmen",
    "native": "Туркмен / تركمن"
  },
  {
    "code": "tw",
    "name": "Twi",
    "native": "Twi"
  },
  {
    "code": "uk",
    "name": "Ukrainian",
    "native": "Українська"
  },
  {
    "code": "ur",
    "name": "Urdu",
    "native": "اردو",
    "rtl": 1
  },
  {
    "code": "ug",
    "name": "Uyghur",
    "native": "Uyƣurqə / ئۇيغۇرچە"
  },
  {
    "code": "uz",
    "name": "Uzbek",
    "native": "Ўзбек"
  },
  {
    "code": "ve",
    "name": "Venda",
    "native": "Tshivenḓa"
  },
  {
    "code": "vi",
    "name": "Vietnamese",
    "native": "Tiếng Việt"
  },
  {
    "code": "vo",
    "name": "Volapük",
    "native": "Volapük"
  },
  {
    "code": "wa",
    "name": "Walloon",
    "native": "Walon"
  },
  {
    "code": "cy",
    "name": "Welsh",
    "native": "Cymraeg"
  },
  {
    "code": "fy",
    "name": "West Frisian",
    "native": "Frysk"
  },
  {
    "code": "wo",
    "name": "Wolof",
    "native": "Wollof"
  },
  {
    "code": "xh",
    "name": "Xhosa",
    "native": "isiXhosa"
  },
  {
    "code": "yi",
    "name": "Yiddish",
    "native": "ייִדיש",
    "rtl": 1
  },
  {
    "code": "yo",
    "name": "Yoruba",
    "native": "Yorùbá"
  },
  {
    "code": "za",
    "name": "Zhuang",
    "native": "Cuengh / Tôô / 壮语"
  },
  {
    "code": "zu",
    "name": "Zulu",
    "native": "isiZulu"
  }
]
